import React, { useState } from 'react'
import { Linking } from 'react-native'

import { colors as zetColors } from '@zet/design-system'
import { Icon } from '@zet/design-system/icons'
import { XStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { B5 } from '@zet/design-system/typography'
import { useUserContext } from '@zet/feature-user'

import ShareWhatsAppMessageForArn from './shareWhatsAppMessageForArn'

interface FaqsWidgetProps {
  phone: string
  brandComms: object
  item: object
  shareButtonsConfig: object
  askCode: string
}

const FaqsWidget: React.FC<FaqsWidgetProps> = ({
  phone,
  brandComms,
  item,
  shareButtonsConfig,
  askCode,
}) => {
  const title =
    shareButtonsConfig?.title?.replace?.(
      '{{customerName}}',
      item?.name ?? ''
    ) || ''

  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false)
  const { data: user } = useUserContext()

  return (
    <>
      <B5 className="my-2">{title}</B5>

      {!!shareButtonsConfig?.types?.length && (
        <XStack className="my-4/2">
          {shareButtonsConfig?.types?.includes?.('call') && (
            <Pressable
              onPress={() => Linking.openURL(`tel:${phone}`)}
              className="mr-4/2 bg-primary-10 rounded"
              eventName="click_action"
              eventPayload={{
                item_name: 'lead_page_faq_dialler',
                page_name: askCode,
                partner_id: item?.partnerId,
                brand_name: brandComms.name,
                lead_id: item?.id,
                user_id: user.id,
                customer_id: item?.customerId,
                arn: item?.referenceId,
              }}
            >
              <Icon
                type="PhoneFilled"
                size={28}
                color={zetColors.primary[100]}
              />
            </Pressable>
          )}
          {shareButtonsConfig?.types?.includes?.('whatsapp') && (
            <>
              <Pressable
                onPress={() => setIsBottomSheetVisible(true)}
                className="mr-4/2 bg-success-10 rounded"
                eventName="click_action"
                eventPayload={{
                  item_name: 'lead_page_faq_whatsapp',
                  page_name: askCode,
                  partner_id: item?.partnerId,
                  brand_name: brandComms.name,
                  lead_id: item?.id,
                  user_id: user.id,
                  customer_id: item?.customerId,
                  arn: item?.referenceId,
                }}
              >
                <Icon
                  type="Whatsapp"
                  size={28}
                  color={zetColors.success[100]}
                />
              </Pressable>
              <ShareWhatsAppMessageForArn
                phone={phone}
                brandComms={brandComms}
                item={item}
                askCode={askCode}
                customerName={item?.name}
                isBottomSheetVisible={isBottomSheetVisible}
                setIsBottomSheetVisible={setIsBottomSheetVisible}
              />
            </>
          )}
        </XStack>
      )}
    </>
  )
}

export default FaqsWidget
